import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { NgbDropdownMenu, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

/**
 * in combination with DownloadService 'progress' this submenu is able to show a loading spinner on download
 */
@Component({
    selector: 'ca-dropdown-submenu',
    templateUrl: './dropdown-submenu.component.html',
    styleUrls: ['./dropdown-submenu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownSubmenuComponent implements AfterViewInit {
    @ViewChild(NgbDropdownMenu) menu!: NgbDropdownMenu;

    @ViewChild('tooltip') tooltip: NgbTooltip;

    @Input() className: string;
    @Input() disabled: boolean = false;
    @Input() autoClose: boolean | 'outside' | 'inside' = true;
    @Input() isBusy: boolean;
    @Input() isBusyIcon = 'download';
    @Output() openChange = new EventEmitter<boolean>();

    constructor(private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        if (this.className) {
            const classNames = this.className.split(' ');
            classNames.forEach((className: string) => this.renderer.addClass(this.menu.nativeElement, className));
        }
    }

    toggleTooltip(event: Event): void {
        event.stopPropagation();

        if (this.tooltip.isOpen()) {
            this.tooltip.close();
        }
    }
}
